import React, { useEffect, useState } from "react";
// import Notes from "./notes";
import Tasks from "./tasks";
// import MainCard from "./mainCard";
import EmployeeList from "./mainCard";
import LeaveShowGrid from "../ogComponent/leaveShowGrid";
import axios from "axios";
import dayjs from "dayjs";


export default function LeftContainer() {
  const [employeeCount, setEmployeeCount] = useState('00');
  const [leaveCount, setLeaveCount] = useState('00');
  const [attendancePercentage, setAttendancePercentage] = useState("0%");
  const showData = {
    "firstHeader": "Total Employees",
    "firstCount": employeeCount,
    "secondHeader": "Attendence",
    "secondCount": attendancePercentage,
    "thirdHeader": "Leaves",
    "thirdCount": leaveCount
  }

   // Function to calculate attendance percentage
   const calculateAttendancePercentage = (totalEmployees, leaves) => {
    if (totalEmployees === 0) return "0%"; // Avoid division by zero
    const attendance = totalEmployees - leaves;
    const percentage = ((attendance / totalEmployees) * 100).toFixed(0);
    return `${percentage}%`;
  };

  // Update attendance percentage whenever employeeCount or leaveCount changes
  useEffect(() => {
    setAttendancePercentage(calculateAttendancePercentage(employeeCount, leaveCount));
  }, [employeeCount, leaveCount]);


  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("accessToken");
      const today = dayjs().format("YYYY-MM-DD");
      // const today = '2025-03-15'

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API}/api/leavemanagement/leaves/filter_by_date/`,
          {
            headers: { Authorization: `Bearer ${token}` },
            params: {
              start_date: today,
              end_date: today,
            },
          }
        );
        setLeaveCount(response.data?.length)
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        // setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <div
      class="leftcontainer d-flex gap-5 ps-3 ps-md-4 pt-3 pt-md-4 pb-2 pb-md-3"
      style={{ paddingTop: "20px" }}
    >
      <div className="fullContainer d-flex flex-column w-100 row-gap-3 row-gap-xxl-4">
        <LeaveShowGrid showData={showData} />
        <Tasks />
        <EmployeeList setEmployeeCount={setEmployeeCount} />
      </div>
    </div>
  );
}
